import { Component, OnInit } from '@angular/core'


@Component({
    selector: 'mp-placeholder',
    templateUrl: './placeholder.html',
    styleUrls: ['./placeholder.scss']
  })
  export class PlaceholderComponent {}


// WEBPACK FOOTER //
// ./src/app/placeholder/placeholder.component.ts